import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { trimAll } from '@improver/shared/utils';
import { Observable } from 'rxjs';

@Injectable()
export class TrimBodyInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.body) {
      return next.handle(
        request.clone({
          body: trimAll(request.body),
        })
      );
    }

    return next.handle(request);
  }
}
